import ArrowLeft from '@assets/icons/arrow-left.svg';
import DeleteIcon from '@assets/icons/delete.svg';
import React from 'react';
import { CHECK_IN_ROUTES } from '@/navigators/routes';
import { CheckInStackParams } from '@/navigators/types';
import { createStyles } from '@/contexts/theme-context';
import { KeyboardAwareScrollView } from '@/components/with-keyboard-aware';
import { ModalContainer } from '@/components/modal-container';
import { OrderCheckInReportIssueForm } from '@/components/order-check-in/order-check-in-report-issue-form';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<
  CheckInStackParams,
  CHECK_IN_ROUTES.CheckInReportAnIssue
>;

export const CheckInReportAnIssueScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const {
    params: { checkInItem, shouldRenderBackIcon },
  } = route;
  const [styles] = useStyles();
  const onBackPress = () => navigation.goBack();
  return (
    <ModalContainer
      navigationHeaderProps={{
        BackButtonIcon: shouldRenderBackIcon ? ArrowLeft : DeleteIcon,
        onBackPress,
      }}
    >
      <KeyboardAwareScrollView
        contentContainerStyle={styles.contentContainer}
        extraSpacing={40} // Account for extra vertical spacing of stylized TextArea
        keyboardDismissMode="on-drag"
      >
        <OrderCheckInReportIssueForm
          checkInItem={checkInItem}
          onSubmit={onBackPress}
        />
      </KeyboardAwareScrollView>
    </ModalContainer>
  );
};

const useStyles = createStyles(() => ({
  contentContainer: {
    flexGrow: 1,
    paddingTop: 24,
  },
}));
